import { QueryClient } from '@tanstack/react-query';
import { ApiException } from './api/client';

export function createQueryClient(): QueryClient {
  return new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: 30_000,
        refetchOnWindowFocus: false,
        // 429 ve 4xx için retry yok — spiral'i besliyor (web ile aynı).
        retry: (failureCount, error) => {
          if (error instanceof ApiException) {
            if (error.statusCode === 429) return false;
            if (error.statusCode >= 400 && error.statusCode < 500) return false;
          }
          return failureCount < 1;
        },
      },
    },
  });
}
